package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ParentEventListItemResponse(
    val id: String? = null,
    @SerialName("event_id") val eventId: String? = null,
    val title: String? = null,
    @SerialName("applicable_to") val applicableTo: String? = null,
    @SerialName("published_on") val publishedOn: String? = null,
    @SerialName("expiry_date") val expiryDate: String? = null,
    val status: String? = null,
    val description: String? = null
)
